import { SvgIcon } from '@mui/material';

import icons from '../icons/sprite.svg';

export default function Icon({ id, ...props }) {
  if (props.viewBox) {
    return (
      <SvgIcon {...props}>
        <use href={`${icons}#${id}`} />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon {...props} inheritViewBox>
      <use href={`${icons}#${id}`} />
    </SvgIcon>
  );
}
